import { render, staticRenderFns } from "./adesione.vue?vue&type=template&id=224427c7&scoped=true&"
import script from "./adesione.vue.ts?vue&type=script&lang=ts&"
export * from "./adesione.vue.ts?vue&type=script&lang=ts&"
import style0 from "./adesione.vue?vue&type=style&index=0&id=224427c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224427c7",
  null
  
)

export default component.exports